import { ReactDatePickerCustomHeaderProps } from "react-datepicker";

import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";

interface PaziaDateRangeHeaderProps extends ReactDatePickerCustomHeaderProps {
  range?: [Date, Date];
}
export const PaziaDateRangeHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  range: propsRange = defaultRange(),
}: PaziaDateRangeHeaderProps) => {
  const range = (start: number, end: number, step: number) => {
    const length = Math.floor((end - start) / step) + 1;
    return Array.from({ length }, (_, i) => start + i * step);
  };

  const getYear = (d: Date) => d.getFullYear();
  const getMonth = (d: Date) => d.getMonth();

  const years = range(
    getYear(propsRange[0] ?? new Date()),
    getYear(propsRange[1] ?? new Date()),
    1
  );

  return (
    <div
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button
        type="button"
        className="text-slate-500 hover:text-slate-900"
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        <IoIosArrowBack size={20} />
      </button>
      <select
        className="form-input w-[75px] dark:bg-slate-700 mr-2"
        value={getYear(ensureDate(date))}
        onChange={({ target: { value } }) => changeYear(Number(value))}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <select
        className="form-input w-[115px] dark:bg-slate-700"
        value={monthNames[getMonth(ensureDate(date))]}
        onChange={({ target: { value } }) =>
          changeMonth(monthNames.indexOf(value))
        }
      >
        {monthNames.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <button
        type="button"
        className="text-slate-500 hover:text-slate-900"
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        <IoIosArrowForward size={20} />
      </button>
    </div>
  );
};

const ensureDate = (date: Date | string) =>
  date instanceof Date ? date : new Date(date);

const defaultRange = () => {
  const start = new Date(2020, 0, 1);
  const fourYearsAhead = new Date();
  fourYearsAhead.setFullYear(fourYearsAhead.getFullYear() + 4);
  return [start, fourYearsAhead] as [Date, Date];
};

const monthNames = [
  "Styczeń",
  "Luty",
  "Marzec",
  "Kwiecień",
  "Maj",
  "Czerwiec",
  "Lipiec",
  "Sierpień",
  "Wrzesień",
  "Październik",
  "Listopad",
  "Grudzień",
];
